import React from 'react';
import WebFont from 'webfontloader';
import Constant from '../common/Constant';

const moment = require('moment');

WebFont.load({
  google: {
    families: ['Montserrat:400,600,700'],
  },
});

export function withDayChange(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        day: moment().format(Constant.DATE_FORMAT),
      };
    }

    componentDidMount() {
      document.addEventListener('visibilitychange', this.checkDay);
    }

    componentWillUnmount() {
      document.removeEventListener('visibilitychange', this.checkDay);
    }

    checkDay = () => {
      const newDay = moment().format(Constant.DATE_FORMAT);

      if (this.state.day !== newDay && this.refs.child.onDayChanged) {
        this.refs.child.onDayChanged(newDay);
      }

      this.setState({
        day: newDay,
      });
    };

    render() {
      return <WrappedComponent ref="child" {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/index.js